import {CARD_LOGOS, COUNTRY_CODES} from '../consts';

export const getAvailablePaymentMethods = ({countryCode}) => {
    const paymentMethods = ['visa', 'mastercard', 'maestro'];

    if (countryCode === COUNTRY_CODES.USA) {
        paymentMethods.push('discover');
    }

    return paymentMethods.map(name => ({
        name,
        logo: CARD_LOGOS[name]
    }));
};
